import React, { Component } from 'react'
import image from '../../mouseimages/hard.jpg'
import '../stylesheets/hardware.css'
export default class Hardware extends Component {
    render() {
        return (
            <div className="hard-container" data-aos="fade-left">
            
              <section className ="hard-content">
                   <h3> 
                    <p>Powered with</p>
                    <p>Powerful</p>
                    <p>Hardware</p>
                    </h3>
                </section>
                <img src={image} alt="hard"></img> 
            </div>
        )
    }
}
